__turbopack_context__.v({
  "count": "JlQDyq_count",
  "default": "JlQDyq_default",
  "indicator": "JlQDyq_indicator",
  "pills": "JlQDyq_pills",
  "tab": "JlQDyq_tab",
  "tabActive": "JlQDyq_tabActive",
  "tabDisabled": "JlQDyq_tabDisabled",
  "tabIcon": "JlQDyq_tabIcon",
  "tabLabel": "JlQDyq_tabLabel",
  "tabs": "JlQDyq_tabs",
  "tabs--lg": "JlQDyq_tabs--lg",
  "tabs--md": "JlQDyq_tabs--md",
  "tabs--sm": "JlQDyq_tabs--sm",
  "underline": "JlQDyq_underline",
});
